import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService, CreateOrganizationPayload } from '@services/organization';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateOrganization = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'create'],
    mutationFn: async (payload: CreateOrganizationPayload) => {
      return await organizationService.createOrganization(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(tActionMessages.organizationCreatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Create organization error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to create organization';
      toast.error(errorMessage);
    },
  });
};

export default useCreateOrganization;